import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';

function EditBillingProductIcon() {
    return (
        <div style={{ maxWidth: "24px" }}>
            <ReceiptIcon />
            <EditIcon sx={{ fontSize: "15px", marginLeft: "-10px", color: "black" }} />
        </div>
    )
}

export default EditBillingProductIcon;